export default {
      id: "response-career-site-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "sprite-46b249.svg#response-career-site-usage",
      toString: function () {
        return this.url;
      }
    }